<template>
  <div class="side-nav">
    <el-scrollbar>
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="true"
        @select="handleSelect"
      >
        <template v-for="menu in menus">
          <el-submenu
            v-if="menu.children && menu.children.length"
            :key="menu.uid"
            :index="menu.uid"
          >
            <template #title>
              <i :class="menu.icon"></i>
              <span>{{ menu.name }}</span>
            </template>
            <template v-for="child in menu.children">
              <el-submenu
                v-if="child.children && child.children.length"
                :key="child.uid"
                :index="child.uid"
              >
                <template #title>{{ child.name }}</template>
                <el-menu-item
                  v-for="subChild in child.children"
                  :key="subChild.uid"
                  :index="subChild.uid"
                >
                  {{ subChild.name }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :key="child.uid"
                :index="child.uid"
              >
                {{ child.name }}
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item
            v-else
            :key="menu.uid"
            :index="menu.uid"
          >
            <i :class="menu.icon"></i>
            <span>{{ menu.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  props: {
    sideMenus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.app.sidebarCollapse
    },
    activeMenu() {
      return this.$store.state.app.activeMenu
    },
    menus() {
      //console.log('----获取二级菜单----')
      // 直接使用 store 中的 sideMenus
      return this.$store.state.app.sideMenus
    }
  },
  methods: {
    handleSelect(uid) {
      console.log(this.$router.getRoutes());
      const menu = this.findMenu(this.sideMenus, uid)
        console.log(menu)
      // 只有type=2的菜单才跳转
    if (menu.type === 2 && menu.path) {
      try {
       
        
         this.$router.push(menu.path)
      } catch (err) {
        console.error('导航失败:', err)
        this.$router.replace('/404')
      }
    }
     
    },
    findMenu(menus, uid) {
      for (const menu of menus) {
        if (menu.uid === uid) return menu
        if (menu.children) {
          const found = this.findMenu(menu.children, uid)
          if (found) return found
        }
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.side-nav {
  width: 200px;
  height: 100%;
  background: #001529;
  transition: width 0.28s;
  
  .el-menu {
    border-right: none;
    background: transparent;
    
    ::v-deep .el-submenu__title,
    ::v-deep .el-menu-item {
      color: rgba(255, 255, 255, 0.65);
      
      i {
        color: inherit;
      }
      
      &:hover {
        color: #fff;
        background-color: transparent !important;
      }
    }
    
    ::v-deep .el-menu-item.is-active {
      color: #fff;
      background-color: #1890ff !important;
    }
  }
  
  &.collapse {
    width: 64px;
  }
}
</style>